/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendBusinessAngelVariantDto } from '../../models/backend-business-angel-variant-dto';
import { BackendBusinessAngelVariantRequestDto } from '../../models/backend-business-angel-variant-request-dto';

export interface VentureFundsBusinessAngelVariantsUpdate$Params {
  id: number;
  body: BackendBusinessAngelVariantRequestDto;
}

export function ventureFundsBusinessAngelVariantsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsBusinessAngelVariantsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendBusinessAngelVariantDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelVariantsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendBusinessAngelVariantDto>;
    }),
  );
}

ventureFundsBusinessAngelVariantsUpdate.PATH = '/api/venture_funds/business-angel-variants/{id}/';
